import http from 'utils/http';
import { USER_TEAM_SUMMARY_URL } from 'constants/endpoints';
import type { ServiceParams } from 'interface/service';

export async function fetchTeamSummary(params: ServiceParams) {
  const { data } = await http.get(USER_TEAM_SUMMARY_URL, { params });

  return data;
}
